export var SYMBOL = '&';
export default function func() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  return params.reduce(function (acc, value) {
    return acc + value.toString();
  }, '');
}
func.SYMBOL = SYMBOL;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_hot-formula-parser@4.0.0@hot-formula-parser/evaluate-by-operator/operator/ampersand.mjs
// module id = null
// module chunks = 